export const PROGRAM_BLOCK_TYPE = 'PROGRAM_ID';